import { Component } from '@angular/core';
import { ListComponent } from 'src/app/common/component/list.component';

@Component({
	selector: 'app-tourist-guides-list',
	templateUrl: './tourist-guides-list.component.html',
	styleUrls: ['./tourist-guides-list.component.css'],
})
export class TouristGuidesListComponent extends ListComponent {
	data: Array<any> = [];
	parameters = {
		date_from: null,
		date_to: null,
		touristGuide: [],
		touristGuideType: [],
		rates: null,
	};
	tableRows = [
		{ id: 'firstName', name: 'Imię' },
		{ id: 'lastName', name: 'Nazwisko' },
		{ id: 'type_name', name: 'Status' },
		{ id: 'emailPrivate', name: 'E-mail prywatny' },
		{ id: 'emailBusiness', name: 'E-mail służbowy' },
		{ id: 'phonePrivate', name: 'Telefon prywatny' },
		{ id: 'phoneBusiness', name: 'Telefon służbowy' },
		{ id: 'birthdate', name: 'Data urodzenia' },
		{ id: 'rate', name: 'Ocena' },
		{ id: 'comments', name: 'Komentarz' },
	];
	protected itemsBeforeDataLoad = 2;
	protected apiUrl = 'tourist-guide';
	protected apiType = 'erpV2';

	protected loadBefore() {
		this.api.get('/touristGuideTypes/', (result, error) => {
			this.parameters.touristGuideType = result.data;
			this.loadData();
		});

		this.api.get('/touristGuides/', (result, error) => {
			result.data.forEach((obj) => {
				obj.name = obj.lastName + ' ' + obj.firstName;
			});
			this.parameters.touristGuide = result.data;
		});
	}

	protected convertData(data) {
		data.forEach((obj) => {
			const type = this.parameters.touristGuideType.find((findObject) => findObject.id == obj.type);
			obj.type_name = type ? type.name : '?';
		});
		return data;
	}
}
